import React, {FC, useContext} from "react";
import {Table} from "react-bootstrap";
import {MatchLabels, SupportUserMatch, toDate} from "services";
import {AppEmojis, AppNames, Apps, UserStatusDesc, UserStatusEmojis} from "enums";
import {toDateString} from "utils";
import {AuthContext} from "contexts";

interface Props {
    matches: SupportUserMatch[];
}

export const ModerationDownloadMatchesBody: FC<Props> = ({matches}) => {
    const {env} = useContext(AuthContext);
    return <div>
        {matches.length > 0
            ? <Table size="sm" bordered responsive className="mb-0">
                <thead>
                <tr>
                    <th>Дата</th>
                    <th>Матч</th>
                    <th>Пользователь</th>
                    <th>Статус юзера</th>
                    <th>Приложение</th>
                </tr>
                </thead>
                <tbody>
                {matches.map((m, i) => {
                    const date = toDate(m.date, env?.app ?? Apps.Instinct);
                    const dateString = date ? toDateString(date, false) : '';
                    return <tr key={`${m.user.key}_${i}`}>
                        <td>{dateString}</td>
                        <td>{MatchLabels[m.status]}</td>
                        <td>
                            <a href={`profile/${m.user.key}`} target="_blank"
                               rel="noreferrer">{m.user.name}</a>
                        </td>
                        <td>{UserStatusEmojis[m.user.status]} {UserStatusDesc[m.user.status]}</td>
                        <td>{AppNames[m.user.appId]} {AppEmojis[m.user.appId]}</td>
                    </tr>
                })}
                </tbody>
            </Table>
            : "У пользователя пока нет мэтчей"}
    </div>
}
